import PropTypes from 'prop-types'
import React from 'react'
import config from 'SRC/config/config.yaml'

export const ProAvailable = ({packages}) => {
  const text = config.registrationForm.package.proavailable
  return <tr>
    <td>{text[0]} <strong>{text[1]}</strong> {text[2]}</td>
    {
      packages.map(item => <td key={item.id}>{<i className={`ico-${item.proAvailable ? `ima` : `nema`} ico`} />}</td>)
    }
  </tr>
}
ProAvailable.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    proAvailable: PropTypes.bool
  })).isRequired
}

ProAvailable.defaultProps = {
  packages: []
}
